<template>
  <div ref="host" @click="onClick"/>
</template>
<script lang="ts">
import {Component, Inject, Prop, toNative} from 'vue-facing-decorator'
import ToastHost from './ToastHost'
import {createViewer, Viewer} from '@/utils/toastui'
import {WORKSPACE} from '@/components/shared/WorkspaceRouteComponent'
import {EnhancedWorkpace} from '@/types/Workspace'
import {followLink, mentionRenderer} from '@/utils/markdownMentionView'

/**
 * Markdown desenhado, somente leitura.
 *
 * `initialValue` é lido só na criação, sem @Watch — era assim no wrapper do Vue 2, e
 * quem redesenha quando o valor muda é a `:key` de quem usa.
 *
 * Numa tela de ambiente, desenha as referências (`[[cidade#5]]`, já expandidas em link por quem passa o
 * texto — ver `markdownMentions`): o item com a régua da cor dele, a coleção com o ícone, a pessoa com a
 * foto. Clicar num item ou numa coleção navega pelo roteador, sem recarregar a página; com Ctrl, ou com
 * o botão do meio, o link é de verdade e abre outra aba.
 */
@Component({name: 'markdown-viewer'})
class MarkdownViewer extends ToastHost<Viewer> {
  @Prop({type: String, default: ''}) readonly initialValue!: string
  @Inject({from: WORKSPACE, default: null}) readonly workspace!: EnhancedWorkpace | null

  create(el: HTMLElement): Viewer {
    return createViewer(el, {initialValue: this.initialValue,
      ...(this.workspace ? {customHTMLRenderer: mentionRenderer(this.workspace)} : {})})
  }

  /** Ver o `followLink`. */
  onClick(event: MouseEvent) {
    followLink(event, this.workspace, href => this.$router.push(href))
  }
}

export default toNative(MarkdownViewer)
</script>
